export const PRODUCTION_ORIGIN = "https://www.transportmate.co.uk";

export const productionUrl = (path: string) =>
  `${PRODUCTION_ORIGIN}${path.startsWith("/") ? path : `/${path}`}`;